// extracted by mini-css-extract-plugin
export var dropdownContainer = "_rm-0";
export var leftAlign = "_rm-4";
export var listItem = "_rm-2";
export var listItemWrapper = "_rm-1";
export var operationText = "_rm-3";